<template>
  <div class="else_dataP else_data_one">
    <!-- <div v-for="(rule,rid) in getSkipLogicDetails[dbQid][ruleNo].rules_array" :key="rid">
      <div class="panel panel-default" :data-que-id="'rule_'+dbQid+'_'+ruleNo+'_if'">
        <div class="panel-heading">
          <h4 class="panel-title">
            <span v-for="(ruleDet,k) in rule" :key="k">
              <span class="display-skip-info" v-if="k === 0">{{ruleDet['st_logical_condition']}}</span>
              <span class="display-skip-info" v-if="k === 0">{{ruleDet['st_rule_type']}}</span>
              <span class="display-skip-info">{{ruleDet['st_answer_value']}}</span>
            </span>
          </h4>
        </div>
      </div>
    </div>-->
    <div
      v-if="getSkipLogicDetails[dbQid][ruleNo]['rules_array'] && getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0] && getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0][0]"
    >
      <div
        class="panel panel-default"
        :data-qid="questionNum"
        :data-que-id="'rule_'+dbQid+'_'+ruleNo+'_if'"
      >
        <div class="panel-heading">
          <h4
            class="panel-title"
            v-if="getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0][0]['st_answer_value'] !== 'NA'"
          >
            <span class="data_1">{{getSkipLogicDetails[dbQid][ruleNo]['in_question_number']}}</span>
            <span class="data_2">
              <i :class="qtypeClassMap[getSkipLogicDetails[dbQid][ruleNo]['in_question_type_id']]"></i>
            </span>
            <span
              class="display-skip-info data_3"
            >{{getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0][0]['st_logical_condition'] === "EQUALS" ? '=' : getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0][0]['st_logical_condition'] === "CONTAINS" ? '<' : 'NA'}}</span>
            <span
              class="display-skip-info data_4"
            >{{getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0][0]['st_rule_type']}}</span>
            <span
              v-if="[vueQueTypeConfig.TYPE_MULTIPLE_IMAGE, vueQueTypeConfig.TYPE_IMAGE].includes(getSkipLogicDetails[dbQid][ruleNo]['in_question_type_id'])"
              class="display-skip-info data_5"
            >
              <i class="fa fa-file-image-o"></i>
            </span>
            <span
              v-else-if="getSkipLogicDetails[dbQid][ruleNo]['in_question_type_id'] === vueQueTypeConfig.TYPE_SATISFACTION"
              class="modal-label ck-span display-skip-info data_5"
              v-tooltip="{content: tooltipAns,html: true}"
            >
              <i
                :class="smileyClass[getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0][0]['st_answer_value']]"
              ></i>
            </span>
            <span
              v-else-if="getSkipLogicDetails[dbQid][ruleNo]['in_question_type_id'] === vueQueTypeConfig.TYPE_STAR"
              class="modal-label ck-span display-skip-info data_5"
              v-tooltip="{content: tooltipAns,html: true}"
            >
              <span class="skiplogic rating star-tooltip">
                <span
                  class="icon"
                  v-for="j in parseInt(getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0][0]['st_answer_value'])"
                  :key="j"
                >★</span>
              </span>
            </span>
            <span
              v-else
              class="display-skip-info data_5"
              v-tooltip="{content: tooltipAns,html: true}"
            >{{getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0][0]['st_answer_value']}}</span>
            <a href.prevent style="cursor:pointer;" class="data_6">
              <i
                class="fa fa-pencil"
                id="editRuleIcon"
                :ruleQid="dbQid"
                :ruleNo="ruleNo"
                :qNo="questionNum"
              ></i>
            </a>
          </h4>
          <h4 class="panel-title" v-else>
            <span class="data_1">{{getSkipLogicDetails[dbQid][ruleNo]['in_question_number']}}</span>
            <span class="data_2">
              <i :class="qtypeClassMap[getSkipLogicDetails[dbQid][ruleNo]['in_question_type_id']]"></i>
            </span>
            <span
              class="display-skip-info data_5"
              v-if="getSkipLogicDetails[dbQid][ruleNo]['st_skiplogic_ansnoans'][0] === 'ANSWERED'"
            >Answered</span>
            <span v-else class="display-skip-info data_5">Not Answered</span>
            <a href.prevent style="cursor:pointer;" class="data_6">
              <i
                class="fa fa-pencil"
                id="editRuleIcon"
                :ruleQid="dbQid"
                :ruleNo="ruleNo"
                :qNo="questionNum"
              ></i>
            </a>
          </h4>
        </div>
      </div>
    </div>
    <div
      v-if="getSkipLogicDetails[dbQid][ruleNo]['rules_array'] && getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0] && getSkipLogicDetails[dbQid][ruleNo]['rules_array'][0][0]"
    >
      <div
        class="panel panel-default bef"
        :data-qid="questionNum"
        :data-que-id="'rule_'+dbQid+'_'+ruleNo+'_else'"
      >
        <div class="panel-heading">
          <h4 class="panel-title">
            <span class="data_7">Else</span>
            <span style="cursor:pointer;" class="trash-right text-right">
              <i id="delRuleIcon" :ruleQid="dbQid" :ruleNo="ruleNo" class="fa fa-trash"></i>
            </span>
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
var {
  queTypeConfig,
  queControlConfig,
  constantCommonConfig
} = require("../../../config/config.js");
export default {
  name: "skipRule",
  props: ["dbQid", "ruleNo", "questionNum"],
  data() {
    return {
      vueQueTypeConfig: queTypeConfig,
      vueQueControlConfig: queControlConfig,
      qtypeClassMap: {
        1: "fas fa-text-width",
        2: "fas fa-text-width",
        3: "fas fa-bars",
        4: "fas fa-circle",
        5: "fas fa-list-ul",
        6: "fas fa-envelope",
        7: "far fa-file-alt",
        8: "fas fa-list-ol",
        9: "fas fa-calendar",
        10: "far fa-clock",
        11: "fas fa-circle",
        12: "fas fa-circle",
        13: "fas fa-list-ul",
        14: "fas fa-list-ol",
        15: "fas fa-list-ol",
        16: "far fa-clock",
        17: "fas fa-image",
        18: "fas fa-camera",
        19: "far fa-thumbs-up",
        20: "far fa-thumbs-up",
        21: "fas fa-barcode",
        22: "fas fa-file-signature"
      },
      smileyClass: {
        ":)": "em em-smile",
        ":|": "em em-neutral_face",
        ":P": "em em-heart_eyes",
        ":@": "em em-angry",
        ":(": "em em-disappointed"
      },
      tooltipAns: ""
    };
  },
  mounted() {
    this.getSkipLogicDetails[this.dbQid][this.ruleNo]["rules_array"][0].forEach(
      (val, k) => {
        if (
          this.getSkipLogicDetails[this.dbQid][this.ruleNo]
            .in_question_type_id === queTypeConfig.TYPE_SATISFACTION
        ) {
          this.tooltipAns =
            this.tooltipAns +
            '<span class="' +
            this.smileyClass[val.st_answer_value] +
            '"></span><br>';
        } else if (
          this.getSkipLogicDetails[this.dbQid][this.ruleNo]
            .in_question_type_id === queTypeConfig.TYPE_STAR
        ) {
          this.tooltipAns = this.tooltipAns + '<span class="skiplogic rating">';
          for (var i = 0; i < val.st_answer_value; i++) {
            this.tooltipAns = this.tooltipAns + '<span class="icon">★</span>';
          }
          this.tooltipAns = this.tooltipAns + "</span><br>";
        } else {
          this.tooltipAns = this.tooltipAns + (val.st_answer_value + "<br>");
        }
      }
    );
  },
  computed: {
    ...mapGetters("editquestionEdit", {
      getSkipLogicDetails: "getSkipLogicDetails"
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/skipRule.vue